/**
 * frontend/src/pages/valuation/_ReviewSteps.tsx
 *
 * VAL-PATH-P7c — the signer's Review step: the owner's six steps, each with a
 * link into the same step screen to correct it. Labels and routes come from
 * _steps.ts, so this list cannot disagree with the owner's own path.
 */
import { Link } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'
import { stepsFor } from './_steps'

/** Owner-approved (OWNER_APPROVALS.log 2026-10-22 15:56 CT, P7C OPEN_AND_EDIT) — the link on each owner step. */
export const OPEN_AND_EDIT = 'Open and edit'

export function ReviewSteps({ id }: { id: string }) {
  return (
    <Card>
      <CardContent>
        {/* Screen-reader label owner-approved (OWNER_APPROVALS.log 2026-10-23 15:06 CT, item 2). */}
        <ol aria-label="The owner's steps" className="divide-y divide-gray-100">
          {stepsFor('valuation_owner').map((step, i) => (
            <li key={step.key} className="flex items-center justify-between gap-4 py-2 text-sm">
              <span className="text-gray-900">{i + 1}. {step.label}</span>
              <Link to={step.route(id)} className="font-semibold text-[#0d1f3c] hover:underline">
                {OPEN_AND_EDIT}
              </Link>
            </li>
          ))}
        </ol>
      </CardContent>
    </Card>
  )
}
